import { ArrowRight, Sparkles } from "lucide-react";

interface Props {
  message: string;
  onSignup: () => void;
  onDismiss: () => void;
}

const FallbackNoMatchCard = ({ message, onSignup, onDismiss }: Props) => {
  return (
    <div className="w-full max-w-2xl mx-auto mt-4 rounded-2xl border border-cyan-400/20 bg-black/60 p-5 md:p-6 animate-fadeUpSoft">
      <div className="flex items-center gap-2 mb-2">
        <Sparkles className="w-4 h-4 text-cyan-300" />
        <p className="text-[10px] uppercase tracking-[0.2em] text-cyan-300 font-mono font-semibold">
          New Pattern Detected
        </p>
      </div>
      <p className="text-white text-base md:text-lg leading-snug">
        Your message doesn't match any of our common pattern templates yet.
      </p>
      <p className="mt-2 text-sm text-white/55 leading-relaxed">
        Create a free account to run a full forensic analysis on this specific message.
      </p>

      <div className="mt-4 rounded-lg border border-white/[0.07] bg-white/[0.02] p-3">
        <p className="text-[10px] uppercase tracking-[0.18em] text-white/35 font-mono mb-1">Your message</p>
        <p className="text-[13px] text-white/70 italic line-clamp-3">"{message}"</p>
      </div>

      <div className="mt-4 flex flex-col sm:flex-row gap-2">
        <button
          onClick={onSignup}
          className="inline-flex items-center justify-center gap-2 h-11 px-5 rounded-lg bg-cyan-500 hover:bg-cyan-400 text-black text-sm font-semibold flex-1 transition-all shadow-[0_0_30px_-6px_rgba(34,211,238,0.85)]"
        >
          Create Free Account
          <ArrowRight className="w-4 h-4" />
        </button>
        <button
          onClick={onDismiss}
          className="inline-flex items-center justify-center h-11 px-5 rounded-lg border border-white/10 text-white/65 hover:bg-white/5 text-sm transition-colors"
        >
          Try a different message
        </button>
      </div>
    </div>
  );
};

export default FallbackNoMatchCard;
